import React, { memo, useState, useEffect } from "react";
import { getDevelopmentPlan } from "@/api/home";
import styles from "./style.module.less";
import { HomeContext } from "@/components/Home/utils";
import { HomeOssUrl as CDN_URL } from "@/components/Home/utils";
import jiantou from "../../../../assets/jiantou.png";
import { Iprops } from "../..";
import Bus from "@/utils/bus";
const arrow = `${CDN_URL}/rightWhite.png`;
const dogPng = `${CDN_URL}/dog.png`;

export interface growsItem {
  title: string | null;
  description: string | null;
  pcUrl: string | null;
  mobileUrl: string | null;
}
export interface growsInterface {
  setting: {
    moduleName: string | null;
    description: string | null;
    pcurl: string | null;
    mobileUrl: string | null;
  };
  contentList: growsItem[];
}
const Grows = memo((props: Iprops) => {
  const [developData, setDevelopData] = useState<growsInterface | null>(null);
  const { appRuntimeEnv, authInfo } = React.useContext(HomeContext);

  const [focus, setFocus] = useState(0);

  useEffect(() => {
    getDevelopmentPlan().then((res: growsInterface) => {
      console.log(res, "getDevelopmentPlan");
      setDevelopData(res);
    });
  }, []);
  const cardClick = () => {
    if (!appRuntimeEnv) return;
    Bus.emit("openHomeH5", {
      pcUrl: "/jqq_h5_pages/#/growthPlan"
    });
  };

  useEffect(() => {
    if (!developData?.contentList?.length) {
      return;
    }
    const intervalTimer = setInterval(() => {
      setFocus((pre) => {
        // console.log("pre",pre,developData?.contentList.length)
        if (pre === developData?.contentList.length - 1) {
          return 0;
        }
        return pre + 1;
      });
    }, 2000);
    return () => {
      console.log("clearInterval");
      intervalTimer && clearInterval(intervalTimer);
    };
  }, [developData]);
  // 先端上写死
  const onMoreClick = () => {
    cardClick();
  };

  const getText = (title: string) => {
    const length = title.length;
    if (length < 6) {
      return (
        <div className={styles.text_wrapper}>
          <span className={styles.text_title}>{title}</span>
        </div>
      );
    } else if (length < 12) {
      return (
        <div className={styles.text_wrapper}>
          <span className={styles.text_title}>{title.slice(0, 6)}</span>
          <span className={styles.text_title}>{title.slice(6)}</span>
        </div>
      );
    } else {
      return (
        <div className={styles.text_wrapper}>
          <span className={styles.text_title_small}>{title.slice(0, 6)}</span>
          <span className={styles.text_title_small}>{title.slice(6, 12)}</span>
        </div>
      );
    }
  };
  return (
    <div className={styles.wrapper}>
      <div className={styles.content} onClick={() => onMoreClick()}>
        <div className={styles.more}>
          <img src={arrow} className={styles.icon} />
        </div>
        <span className={styles.txt13}>{developData?.setting?.moduleName}</span>
        <span className={styles.txt14}>{developData?.setting?.description}</span>

        <div className={styles.grows_wrap}>
          {developData?.contentList?.map((item: growsItem, index: number) => {
            return (
              <div
                // onClick={(e) => {
                //   // onItemClick(item,e)
                // }}
                className={`${styles.grows_item} ${styles["grows" + (index + 1)]} ${
                  focus === index ? styles.grows_item_focus : ""
                }`}
              >
                {getText(item.title || "")}
              </div>
            );
          })}
          <img src={dogPng} className={`${styles.dog} ${styles["dogs" + (focus + 1)]}`} />
        </div>
      </div>
      <img src={jiantou} className={styles.jiantou} />
    </div>
  );
});

export default Grows;
